import React from 'react'
import {Button} from './core/button.js'
// import Slot from './slot.js'

import SlotMachine from 'react-slot-machine';

export default class SlotScreen extends React.Component{
	constructor(props) {
		super(props)
		this.state = {
			showGender: false,
			showProfession: false,
			showNationality: false,
			infoClass: 'info',
			buttonClass: 'button',
			turn: false,
		}
	}

	buildTextWithSlotmachineData = () => {
		const {
			data,
			gender_id,
			gender,
			nationality,
			profession,
			religion,
		} = this.props

		let rawText = data.screen_3.text_3
		const residence = data.properties.residence
		const article = data.screen_3[`text_2_${gender_id}`]
		let newText

		let newNationality = this.getTextFromData(nationality, gender_id)
		let newReligion = this.getTextFromData(religion, gender_id)
		let newProfession = this.getTextFromData(profession, gender_id)
		
		newText = article + ' ' +
			rawText.replace('{nationality}', newNationality)
				.replace('{religion}', newReligion)
				.replace('{profession}', newProfession)
				.replace('{residence}', residence)

		return newText
	}

	getTextFromData = (property,gender_id) => {
		let text = property.field[gender_id]
		return text
	}

	turnTheWheel = () => {
		this.setState({
			turn: true
		})
	}

	componentDidMount() {
		setTimeout(() => { 
			this.setState({
				turn: true,
			})
		}, 1000)

		setTimeout(() => { 
			this.setState({
				infoClass: 'info info--visible',
				buttonClass: 'bottomButton button button--visible',
			}) 
		}, 3500)
	}

	render(){
		const {
			data, 
			handler,
			gender,
			nationality,
			profession,
			religion,
			lang,
			machineData
		} = this.props

		const {
			showGender,
			showNationality,
			showProfession,
			infoClass,
			buttonClass,
			turn,
		} = this.state

		const nationalities = []
		nationalities.push('default.png')
		for (const i in data.properties.nationalities) {
			nationalities.push(data.properties.nationalities[i].field.icon_schwarz.filename)
		}
		const genders = []
		genders.push('default.png')
		for (const i in data.properties.genders) {
			genders.push(data.properties.genders[i].field.icon_schwarz.filename)
		}
		const professions = []
		professions.push('default.png')
		for (const i in data.properties.professions) {
			professions.push(data.properties.professions[i].field.icon_schwarz.filename)
		}
		const religions = []
		religions.push('default.png')
		for (const i in data.properties.religions) {
			religions.push(data.properties.religions[i].field.icon_schwarz.filename)
		}
		
		const slotData = data.screen_3
		const headline = slotData.text_1
		const info = this.buildTextWithSlotmachineData()
		const button = slotData.button


		return (
			<div className='slotscreen'>
				<div className='headline'>{headline}</div>
				<div className='slotsContainer'>
					<SlotMachine 
						className="slot"
						duration={2000}
						target={turn? machineData[0] + 1 : 0}
						times={3}>
					{
						nationalities.map((value, id) =>
						<div key={id} className="slot-item" style={{width: '100%', height: '100%'}}>
							<div className='icon_wrapper'>
								<img className='icon' src={`de/properties/${value}`}/>
							</div>
						</div>
						)
					}
					</SlotMachine>
					<SlotMachine 
						className="slot"
						duration={2500}
						target={turn? machineData[1] + 1 : 0}
						times={3}>
					{
						genders.map((value, id) =>
						<div key={id} className="slot-item" style={{width: '100%', height: '100%'}}>
							<div className='icon_wrapper'>
								<img className='icon' src={`de/properties/${value}`}/>
							</div>
						</div>
						)
					}
					</SlotMachine>
					<SlotMachine 
						className="slot"
						duration={3000}
						target={turn? machineData[2] + 1 : 0}
						times={3}>
					{
						professions.map((value, id) =>
						<div key={id} className="slot-item" style={{width: '100%', height: '100%'}}>
							<div className='icon_wrapper'>
								<img className='icon' src={`de/properties/${value}`}/>
							</div>
						</div>
						)
					}
					</SlotMachine>
					<SlotMachine 
						className="slot"
						duration={3500}
						target={turn? machineData[3] + 1 : 0}
						times={3}>
					{
						religions.map((value, id) =>
						<div key={id} className="slot-item" style={{width: '100%', height: '100%'}}>
							<div className='icon_wrapper'>
								<img className='icon' src={`de/properties/${value}`}/>
							</div>
						</div>
						)
					}
					</SlotMachine>
				</div>
				<div className={infoClass}>{info}</div>
				<Button
		 			className={buttonClass}
		 			name={"Weiter"}
		 			handler={handler}
		 		/>
			</div>
		)

		// list.map((value, id) =>
		// 			<div key={id} className="slot-item" style={{width: '100%', height: '100%'}}>
		// 				{value.name}
		// 			</div>
		// 			)
		// return(
		// 	<div className='slotscreen'>
		// 		<div className='headline'>{headline}</div>
		// 		<div className='slotContainer'>
		// 			{showNationality ?
		// 				<Slot
		// 					icon={nationality}
		// 					lang={lang}
		// 					delay={0}
		// 				/> : null
		// 			}
		// 			{showGender ?
		// 				<Slot
		// 					icon={gender}
		// 					lang={lang}
		// 				/> : null
		// 			}
		// 			{showProfession ? 
		// 				<Slot
		// 					icon={profession}
		// 					lang={lang}
		// 				/> : null
		// 			}
		// 			<Slot
		// 				icon={religion}
		// 				lang={lang}
		// 			/>
		// 		</div>
		// 		<div className={infoClass}>{info}</div>
		// 		<Button
		// 			className={buttonClass}
		// 			name={button}
		// 			handler={handler}
		// 		/>
		// 	</div>
		// )
	}
}



// WEBPACK FOOTER //
// ./src/components/slotScreen.js